// Плагин для markdown-it для обработки ссылок на диалоги Chatwoot
// Распознает ссылки вида [#XXXX название](/app/accounts/.../conversations/XXXX)
// и рендерит их с названием диалога

const CONVERSATION_LINK_REGEX = /^\/app\/accounts\/\d+\/conversations\/(\d+)/;

const buildConversationLinkTokens = () => (state, silent) => {
  var label;
  var labelEnd;
  var labelStart;
  var pos;
  var res;
  var token;
  var href = '';
  var max = state.posMax;

  if (state.src.charCodeAt(state.pos) !== 0x5b /* [ */) {
    return false;
  }

  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) {
    return false;
  }

  label = state.src.slice(labelStart, labelEnd);
  pos = labelEnd + 1;

  if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
    pos += 1;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }
    pos += 1;
  }

  // Проверяем, является ли это ссылкой на диалог Chatwoot
  if (!href.match(CONVERSATION_LINK_REGEX)) {
    return false;
  }

  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token = state.push('conversation_link', '');
    token.href = href;
    token.content = label;
    // Извлекаем display_id из URL
    const match = href.match(CONVERSATION_LINK_REGEX);
    token.displayId = match ? match[1] : null;
  }

  state.pos = pos;
  state.posMax = max;

  return true;
};

const renderConversationLink = () => (tokens, idx) => {
  const token = tokens[idx];
  const href = token.href;
  const content = token.content || `#${token.displayId}`;
  
  // Используем весь текст ссылки (может быть "#XXXX название")
  const displayText = content.trim();
  
  // Экранируем HTML для безопасности
  const escapedText = displayText
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
  
  return `<a href="${href}" class="link conversation-link" data-conversation-id="${token.displayId}">${escapedText}</a>`;
};

export default function conversationLinkPlugin(md) {
  md.renderer.rules.conversation_link = renderConversationLink(md);
  // Обрабатываем перед обычными ссылками, но после mentions
  md.inline.ruler.before('link', 'conversation_link', buildConversationLinkTokens(md));
}


